module.exports = "https://coursera_assets.s3.amazonaws.com/images/c96017c70b1e1eb99e85c2271662944b.png";